import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import style from './RichText.module.css';

const RichText = ({ value, onChange, label, name }) => {
  return (
    <div className={style.wrapper}>
      <label className={style.label}>{label}</label>

      <div className={style.editor}>
        <ReactQuill
          theme="snow"
          value={value || ''}
          onChange={(content) => onChange(content, name)}
          modules={{
            toolbar: [
              [{ header: [1, 2, 3, false] }],
              ['bold', 'italic', 'underline'],
              [{ list: 'ordered' }, { list: 'bullet' }],
              ['link'],
              ['clean']
            ]
          }}
        />
      </div>
    </div>
  );
};

export default RichText;